import { gql } from 'apollo-boost';

/*
{
    "id": "/api/completeness-groups/1"
}
 */
export const GET_COMPLETENESSGROUP_BY_ID = gql`
query getCompletenessGroup($id: ID!){
  completenessGroup(id:$id) {
    id
    libelle
    completenessGroupAttributes{
      edges{
        node{
          id
          isForParent
          attribute{
            id
            identifier
          }
        }
      }
    }
  }
}
`;

export const GET_COMPLETENESSGROUPS = gql`
{
  completenessGroups {
    edges{
      node{
        id
        libelle
        completenessGroupAttributes{
          edges{
            node{
              id
              isForParent
              attribute{
                id
                identifier
              }
            }
          }
        }
      }
    }
  }
}
`;

/*
{
  "libelle": "test group",
  "attributes": [
    "/api/attributes/1",
    "/api/attributes/2"
  ]
}
 */
export const CREATE_COMPLETENESSGROUP = gql`
mutation createCompletenessGroup($libelle: String!, $assets: [String]){
  createCompletenessGroup(input:{libelle: $libelle, assets: $assets}) {
    completenessGroup{
      id
      libelle
    }
  }
}
`;

/*
{
  "id": "/api/completeness-groups/1",
  "libelle": "test group",
  "attributes": [
   "/api/attributes/1",
   "/api/attributes/2"
  ]
}
 */
export const UPDATE_COMPLETENESSGROUP = gql`
mutation updateCompletenessGroup($id: ID!, $libelle: String, $assets: [String]){
  updateCompletenessGroup(input:{id: $id, libelle: $libelle, assets: $assets}) {
    completenessGroup{
      id
      libelle
      completenessGroupAttributes{
        edges{
          node{
            id
            isForParent
            attribute{
              id
              identifier
            }
          }
        }
      }
    }
  }
}
`;

/*
{
  "id": "/api/completeness-groups/1"
}
 */
export const DELETE_COMPLETENESSGROUP = gql`
mutation deleteCompletenessGroup($id: ID!){
  deleteCompletenessGroup(input:{id: $id}) {
    completenessGroup{
      id
    }
  }
}
`;


export const createCompletenessGroupAttribute = gql`
mutation createCompletenessGroupAttribute($completenessGroup: String!, $attribute: String!,$isForParent: Boolean!){
  createCompletenessGroupAttribute(input:{completenessGroup: $completenessGroup, attribute: $attribute, isForParent: $isForParent}) {
    completenessGroupAttribute{
      id
    }
  }
}
`;

export const updateCompletenessGroupAttribute = gql`
mutation updateCompletenessGroupAttribute($id: ID!, $attribute: String,$isForParent: Boolean){
  updateCompletenessGroupAttribute(input:{id: $id, attribute: $attribute, isForParent: $isForParent}) {
    completenessGroupAttribute{
      id
    }
  }
}
`;

export const deleteCompletenessGroupAttribute = gql`
mutation deleteCompletenessGroupAttribute($id: ID!){
  deleteCompletenessGroupAttribute(input:{id: $id}) {
    completenessGroupAttribute{
      id
    }
  }
}
`;